var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7494 0.485352H4.61823C3.64463 0.485352 2.7109 0.872113 2.02247 1.56055C1.33403 2.24899 0.947266 3.18271 0.947266 4.15631V16.3929C0.947266 17.3665 1.33403 18.3002 2.02247 18.9886C2.7109 19.6771 3.64463 20.0638 4.61823 20.0638H21.7494C22.723 20.0638 23.6567 19.6771 24.3451 18.9886C25.0336 18.3002 25.4203 17.3665 25.4203 16.3929V4.15631C25.4203 3.18271 25.0336 2.24899 24.3451 1.56055C23.6567 0.872113 22.723 0.485352 21.7494 0.485352V0.485352ZM21.7494 2.93266L13.7956 8.40239C13.6096 8.50979 13.3986 8.56633 13.1838 8.56633C12.969 8.56633 12.758 8.50979 12.572 8.40239L4.61823 2.93266H21.7494Z",
    fill: "#C996CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRegister);
export default __webpack_public_path__ + "static/media/email_register.e0050df34f4616b0e15fd4d02e1c7788.svg";
export { ForwardRef as ReactComponent };